import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import PhoneForm from '../../../components/PhoneForm';
import { useAuthentication } from '../../../state/Authentication';

const PhoneAdd: React.FC = () => {
  const {
    state: { user },
  } = useAuthentication();
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    if (user.phonePrimary) {
      const queryParams = new URLSearchParams(location.search);

      const redirectUrl = `/gegevens/aanmeldsleutels/telefoon/wijzigen${
        queryParams.toString() ? `?${queryParams.toString()}` : ''
      }`;

      history.replace(redirectUrl);
    }
  }, [user.phonePrimary, history, location.search]);

  const redirectUrl = new URLSearchParams(location.search).get('redirectUrl') || '';

  return <PhoneForm copyIdentifier="add" redirectUrl={redirectUrl} />;
};

export default PhoneAdd;
